import { useOrganizationContext } from 'src/sections/@dashboard/organization/hooks/useOrganizationContext';
import { Roles } from 'src/types/User';

export interface WarehouseAccess {
  /** Owner/admin acting as such: writes and purchase prices. */
  canManage: boolean;
  /**
   * Owner/admin/professional acting as such (the backend's
   * `WAREHOUSE_READ_ROLES`): legal history such as the Drug Record Card and
   * the batch trace.
   */
  canRead: boolean;
}

/** Gated on the selected organization role, not on the roles a user merely has. */
export function useWarehouseAccess(): WarehouseAccess {
  const { selectedRole } = useOrganizationContext();
  const canManage =
    selectedRole === Roles.organization_admin ||
    selectedRole === Roles.organization_owner;
  return {
    canManage,
    canRead: canManage || selectedRole === Roles.professional,
  };
}
